import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCookies } from 'react-cookie';
import { Formik, Form, Field } from '@phishtool/ui';
import * as analytics from '@phishtool/analytics';
import { StyledCookieBannerWrapper, StyledCookieBannerHeading } from './styled';
import { Paragraph } from '~components/paragraph';
const CookieBanner = () => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 10);
    const [cookies, setCookie] = useCookies(['phishtool-cookies']);
    const hasCookie = !!cookies['phishtool-cookies'];
    const initialValues = {
        type: 'all',
    };
    return hasCookie ? null : (_jsxs(StyledCookieBannerWrapper, { children: [_jsx(StyledCookieBannerHeading, { children: "Cookies on PhishTool" }), _jsx(Paragraph, { spacer: "x3", children: "We use necessary cookies to make PhishTool work. We'd also like to set analytics cookies that help us make improvements by measuring how you use PhishTool." }), _jsx(Formik, { initialValues: initialValues, onSubmit: (values) => {
                    analytics.setOptOut(values.type === 'necessary');
                    setCookie('phishtool-cookies', values.type, {
                        expires,
                        path: '/',
                        sameSite: 'lax',
                        // Secure on HTTPS only — window.location is the browser's real protocol (unaffected by the
                        // server-side X-Forwarded-Proto issue); left off over local HTTP so the cookie still sets.
                        secure: window.location.protocol === 'https:',
                    });
                }, children: (props) => (_jsx(Form, { submitText: "Accept", submitTheme: "upgrade", formikProps: props, spacer: "x0", children: _jsx(Field, { type: "radio", name: "type", options: [
                            {
                                value: 'all',
                                label: 'Accept all cookies',
                            },
                            {
                                value: 'necessary',
                                label: 'Accept only necessary cookies',
                            },
                        ], formikProps: props }) })) })] }));
};
export default CookieBanner;
